<template>
  <header-layout>
    <section id="login" v-if="!registerSent">
      <div class="container">
        <div class="columns">

          <div class="column is-half is-offset-one-quarter">

            <div class="columns">
              <div class="column">
                <div class="tabs is-fullwidth is-centered">
                  <ul>
                    <li :class="(section == 'signin')?'is-active':''">
                      <a href="javascript:;" @click="section = 'signin'">SIGN IN</a>
                    </li>
                    <li :class="(section == 'signup')?'is-active':''">
                      <a href="javascript:;" @click="section = 'signup'">SIGN UP</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="columns">

              <div v-if="section == 'signin'" class="column is-10 is-offset-1">
                <form class="form">
                  <h1 class="title">Sign in to your account</h1>
                  <p class="content">Welcome back!<br>Resume your Fun Learning adventure.</p>
                  <p class="content">Sign in with one of these services:</p>

                  <div class="columns">
                    <div class="column">
                      <a class="button button-social is-fullwidth is-outlined" @click="auth('google')">
                        <span class="icon google"></span>
                        <span>Google</span>
                      </a>
                    </div>
                    <div class="column">
                      <a class="button button-social is-fullwidth is-outlined" @click="auth('facebook')">
                        <span class="icon facebook"></span>
                        <span>Facebook</span>
                      </a>
                    </div>
                  </div>

                  <hr>

                  <p class="content">or just use your email:</p>

                  <div v-if="loginErrorMessage" class="notification is-danger has-text-center">
                    {{ loginErrorMessage }}
                  </div>

                  <div class="field">
                    <label class="label">Email</label>
                    <div class="control">
                      <input class="input" type="email" v-model="loginEmail">
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">Password</label>
                    <div class="control">
                      <input class="input" type="password" v-model="loginPass">
                    </div>
                  </div>
                  <!-- <div class="field">
                    <div class="control">
                      <small>By signing up, I agree to the <a>Terms of Service.</a></small>
                    </div>
                  </div> -->
                  <div class="columns">
                    <div class="column is-three-fifths is-offset-one-fifth">
                      <button :class="'button is-fullwidth' + (logging ? ' is-loading': '')" type="submit" @click.prevent="login()">Log in</button>
                    </div>
                  </div>
                  <div class="has-text-centered">
                    <br>
                    <router-link :to="{ name: 'password-reset-email' }"><small>Forgot your password?</small></router-link>
                  </div>
                </form>
              </div>

              <div v-if="section == 'signup'" class="column is-10 is-offset-1">
                <form class="form">
                  <h1 class="title">Create your account</h1>
                  <p class="content">Discover innovative early education solutions, resources and digital tools.<br>Start your Fun Learning adventure today!</p>
                  <p class="content">Sign up with one of these services:</p>

                  <div class="columns">
                    <div class="column">
                      <a class="button button-social is-fullwidth is-outlined" @click="auth('google')">
                        <span class="icon google"></span>
                        <span>Google</span>
                      </a>
                    </div>
                    <div class="column">
                      <a class="button button-social is-fullwidth is-outlined" @click="auth('facebook')">
                        <span class="icon facebook"></span>
                        <span>Facebook</span>
                      </a>
                    </div>
                  </div>

                  <hr>

                  <p class="content">or create an account using your email:</p>

                  <div v-if="registerErrorMessage" class="notification is-danger has-text-center">
                    {{ registerErrorMessage }}
                  </div>

                  <div class="field">
                    <label class="label">Email</label>
                    <div class="control">
                      <input class="input" type="text" v-model="registerEmail">
                    </div>
                  </div>

                  <div class="field is-horizontal">
                    <div class="field-body">
                      <div class="field">
                        <label class="label">Password</label>
                        <div class="control">
                          <input class="input" type="password" v-model="registerPass">
                        </div>
                      </div>
                      <div class="field">
                        <label class="label">Repeat Password</label>
                        <div class="control">
                          <input class="input" type="password" v-model="registerConfirmPass">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="field">
                    <div class="control">
                      By signing up, you agree to the <router-link :to="'termsofuse'">Fun Learning Terms of Service.</router-link>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-three-fifths is-offset-one-fifth">
                      <button class="button is-fullwidth" :class="{ 'is-loading': registering }" type="submit" @click.prevent="registration()">Create your account</button>
                    </div>
                  </div>
                </form>
              </div>

            </div>

          </div>
        </div>
      </div>
    </section>

    <section id="email-validation" v-if="registerSent">
      <div class="container">
        <div class="columns">
          <div class="column is-half is-offset-one-quarter">
            <div class="column">
              <div class="card has-border-dark has-text-centered">
                <div class="card-content">
                  <p>We just sent an email to your inbox, please click the link in there to complete the signup process!</p>
                  <br>
                  <p><em><small>Tip: If you can't find it, check your spam folder, just in case</small></em></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </header-layout>
</template>

<script>
import HeaderLayout from '@/layouts/HeaderLayout'
import Utils from '@/utils/Utils'
import UserService from '../services/UserService'

const R = require('ramda')

const Patterns = {
  EMAIL: /.+@.+\..+/i
}

export default {
  components: {
    HeaderLayout
  },

  computed: {
    isAuthenticated () { return this.$store.state.isAuthenticated }
  },

  methods: {
    goToHome () {
      this.$router.push({ name: 'home' })
    },

    login () {
      if (this.logging) {
        return false
      }
      this.logging = true

      const handleValidationError = (res) => {
        if (res.hasOwnProperty('data')) {
          this.loginErrorMessage = res.data.meta.message
        } else {
          this.loginErrorMessage = res.meta.message
        }
      }
      const disableLoadingIcon = () => {
        this.logging = false
        return false
      }

      const email = this.loginEmail
      const password = this.loginPass

      if (!email) {
        this.loginErrorMessage = `The email field can't be empty`
        this.logging = false
        return false
      }

      if (Patterns.EMAIL.exec(this.loginEmail) === null) {
        this.loginErrorMessage = 'Please enter a valid email'
        this.logging = false
        return false
      }

      if (!password) {
        this.loginErrorMessage = `The password field can't be empty`
        this.logging = false
        return false
      }

      UserService.login(email, password).then(R.compose(disableLoadingIcon, (res) => {
        if (res.meta.code === 200) {
          let user = res.data.user
          let apitoken = res.data.apitoken
          this.$store.dispatch('saveAuthenticatedUser', { user })
          this.loginErrorMessage = false
          Utils.setApiToken(apitoken, user)
          this.$router.push(this.$route.params.redirect || 'dashboard')
          this.logging = false
          return true
        } else {
          handleValidationError(res)
          this.logging = false
          return false
        }
      }), R.compose(disableLoadingIcon, err => {
        handleValidationError(err.response)
        this.logging = false
        return true
      }))
    },

    registration () {
      this.registering = true

      const email = this.registerEmail
      const password = this.registerPass
      const confirmPassword = this.registerConfirmPass

      if (!email) {
        this.registerErrorMessage = ` Please add an email to continue`
        return
      }
      if (!password) {
        this.registerErrorMessage = ` Add the password to continue`
        return
      }
      if (password !== confirmPassword) {
        this.registerErrorMessage = ` The passwords are not the same`
        return
      }

      this.$store.dispatch('register', { email, password })
        .then(res => {
          if (res.meta.code === 200) {
            this.registerSent = true
          } else {
            this.registerErrorMessage = res.meta.errors
          }
        }).catch(error => {
          this.registerErrorMessage = error.response.data.meta.message
          return false
        }).finally(() => {
          this.registering = false
        })
    },

    auth (provider) {
      this.$store.dispatch('authenticate', { provider })
        .then(res => Utils.setApiToken(res.apitoken, JSON.parse(res.user)))
        .then(() => this.$router.push(this.$route.params.redirect || 'dashboard'))
    },

    logout () {
      this.$store.dispatch('logout')
        .then(res => Utils.unsetApiToken())
        .then(this.goToHome)
    }
  },

  data () {
    return {
      logging: false,
      section: 'signin',
      loginEmail: '',
      loginPass: '',
      registerEmail: '',
      registerPass: '',
      registerConfirmPass: '',
      registering: false,
      registerSent: false,
      loginErrorMessage: '',
      registerErrorMessage: ''
    }
  }
}
</script>

<style lang="scss">

#email-validation {
  margin: 6rem 0;
}

#login{
  display: flex;
  margin: 3rem 0;

  .title{
    text-align: center;
  }

  .content{
    font: 1rem;
    text-align: center;
  }

  .tabs{

    a{
      font-size: 0.75rem;
      font-weight: bolder;
    }

    li.is-active a{
      border-width: 3px;
      border-bottom-color: #e31c79;
      color: #e31c79;
    }

  }

  .button {

    &.button-social{

      background-color: #fff;
      color: #0A2239;
      border: 1px solid #C1C3CC;
      border-radius: 4px;

      .icon{
        &.facebook{
          width: 36px;
          height: 18px;
          background: url(/static/img/logo_fb.svg);
          background-size: 36px 18px;
        }
        &.google{
          width: 18px;
          height: 18px;
          background: url(/static/img/logo_google.svg);
          background-size: 18px 18px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/LoginPage.vue